// extracted by mini-css-extract-plugin
export default {"withOnClickHandler":"rYiAuL","filter-effect-svg":"gSXewE","filterEffectSvg":"gSXewE"};